'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiUser = function ApiUser(Restangular, ApiBaseResponseService) {
    _classCallCheck(this, ApiUser);

    return {

        /**
         * Sign up user
         */
        signUpUser: function signUpUser(user) {
            return Restangular.all('users').all('register').post(user).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Edit of current user
         * @param  {Object} user
         * @return {void}
         */
        changeUser: function changeUser(user, isPurchase) {
            return Restangular.one('users', user.userId).customPUT(user, '', { 'purchase': isPurchase }).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        getUser: function getUser() {
            return Restangular.all('users').customGET('getUserData').then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        getTaxRate: function getTaxRate() {
            return Restangular.one('users/taxRate').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        toggleFreezeUser: function toggleFreezeUser(id) {
            return Restangular.all('users').all('freeze').post(null, { userId: id }).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        deactivateStartupWizard: function deactivateStartupWizard() {
            return Restangular.all('users').all('deactivateStartupWizard').post().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        }
    };
};

ApiUser.inject = ['Restangular', 'ApiBaseResponseService'];

exports.default = ApiUser;


/** WEBPACK FOOTER **
 ** ./src/app/services/apiUser.js
 **/